import { render } from "./CheckoutInvesting.vue?vue&type=template&id=35fba7e3"
import script from "./CheckoutInvesting.vue?vue&type=script&lang=js"
export * from "./CheckoutInvesting.vue?vue&type=script&lang=js"

import "./CheckoutInvesting.vue?vue&type=style&index=0&id=35fba7e3&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__